import React from 'react';
import { formatDate, isSameDate } from '../../utils/dateUtils';

function HolidayCalendar({ holidays }) {
  const today = new Date();
  const month1 = new Date(today.getFullYear(), today.getMonth(), 1);
  const month2 = new Date(today.getFullYear(), today.getMonth() + 1, 1);

  const renderMonth = (monthDate) => {
    const year = monthDate.getFullYear();
    const month = monthDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const firstDayOfWeek = firstDay.getDay(); // 0=日曜日, 6=土曜日
    const daysInMonth = lastDay.getDate();

    const monthNames = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];

    const days = [];
    
    // 最初の週の空セルを追加（該当月の最初の日が何曜日かによって）
    for (let i = 0; i < firstDayOfWeek; i++) {
      days.push({ isEmpty: true });
    }
    
    // 該当月の日付のみを追加
    for (let day = 1; day <= daysInMonth; day++) {
      const currentDate = new Date(year, month, day);
      const dateStr = formatDate(currentDate);
      const isHoliday = holidays.includes(dateStr);
      const isToday = isSameDate(currentDate, today);

      days.push({
        date: currentDate,
        dateStr,
        day,
        isHoliday,
        isToday,
        isEmpty: false
      });
    }

    return (
      <div className="public-holiday-calendar-month">
        <h4>{year}年{monthNames[month]}</h4>
        <div className="public-holiday-calendar-grid">
          {weekdays.map((day, idx) => (
            <div key={idx} className="public-holiday-calendar-day-header">{day}</div>
          ))}
          {days.map((day, idx) => {
            if (day.isEmpty) {
              return <div key={idx} className="public-holiday-calendar-day empty"></div>;
            }
            
            let classes = 'public-holiday-calendar-day';
            if (day.isHoliday) classes += ' holiday';
            if (day.isToday) classes += ' today';

            return (
              <div key={idx} className={classes}>
                {day.day}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <section id="schedule" className="schedule">
      <div className="container">
        <h2 className="section-title">カレンダー</h2>
        <div className="calendar-legend">
          <div className="calendar-legend-item">
            <span className="calendar-legend-color-box holiday"></span>
            <span className="calendar-legend-label">休業日</span>
          </div>
        </div>
        <div className="public-holiday-calendars-container">
          {renderMonth(month1)}
          {renderMonth(month2)}
        </div>
      </div>
    </section>
  );
}

export default HolidayCalendar;

